import { Injectable } from '@angular/core'
import { environment } from '../../../../../environments/environment'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { ResponseRequestModel } from '../../../models/response.model'


import {
  SearchPersonDocumentModel,
} from '../../../models/person-document.model'

@Injectable({
  providedIn: 'root',
})
export class PersonDocumentService {
  private baseUrl = environment.baseUrl
  private resource = 'PessoaDocumento'

  constructor(private httpClient: HttpClient) {}

  public uploadPersonDocument(
    // model: CreatePersonDocumentModel,
    model: any,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/upload`,
      model,
    )
  }

  public editPersonDocument(
    model: any,
    // model: EditPersonDocumentModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/edit`,
      model,
    )
  }

  public deletePersonDocument(
    id: number,
    model: any,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/delete/${id}`,
      model,
    )
  }

  public listPagedPersonDocument(
    page: number,
    rows = 15,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listpaginated?pageNumber=${page}&pageSize=${rows}`,
    )
  }

  public listPagedPersonDocumentById(
    idPerson: number,
    page: number,
    rows = 15,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listpaginated/pessoa/${idPerson}?pageNumber=${page}&pageSize=${rows}`,
    )
  }

  public listPersonDocument(): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listall`,
    )
  }

  public listPersonDocumentbyId(
    idPerson: number,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/pessoa/${idPerson}`,
    )
  }

  public searchPersonDocument(
    model: SearchPersonDocumentModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/search`,
      model,
    )
  }

  public getPersonDocumentbyId(id: number): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/${id}`,
    )
  }

  public searchPagedPersonDocument(
    page: number,
    rows = 15,
    model: SearchPersonDocumentModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/search-paginated?pageNumber=${page}&pageSize=${rows}`,
      model,
    )
  }

  public downloadPersonDocument(id: number): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/download/${id}`,
    )
  }
}
